import {AbstractEvent} from "@/modules/base/events";
import {Terrace} from "@/modules/stadium/entity";

export class AfterTerraceExpendedEvent extends AbstractEvent {
  constructor(
    public terrace: Terrace,
  ) {
    super();
  }
}